export enum ConnectionStatusEnum {
  CONNECTED,
  PENDING,
  DISCONNECTED,
}

export interface ConnectionStatusInterface {
  status?: ConnectionStatusEnum;
}
